import type { ReactNode } from 'react';

import { cn } from '@shared/ui/cn';

/**
 * The grid the figures sit in.
 *
 * Two columns at the base tier: one column at 320 px gives four cards a full
 * screen each and pushes the table beneath them out of sight, and three narrow
 * the figure to the width where it breaks. Four from `--bp-md`, and three where
 * the section carries three figures — a fourth empty cell reads as a figure
 * that failed to arrive.
 *
 * It deliberately stays at four on the wide tier: the design system declares no
 * count there, and a fifth column would narrow each card rather than widen the
 * page.
 */
export function StatGrid({ columns = 4, children }: { columns?: 3 | 4; children: ReactNode }) {
  return (
    <div className={cn('mb-5 grid grid-cols-2 gap-3', columns === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3')}>
      {children}
    </div>
  );
}
